import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import RestrictedHtmlEditingCommand from './restrictedhtmlcommand';

export default class RestrictedHtmlEditing extends Plugin {
  init() {
    this.editor.commands.add('toggleRestrictedEditing', new RestrictedHtmlEditingCommand(this.editor));
  }
}
